<template>
  <div v-if="gigs.length > 0">
    <GigComponent
      v-for="gig in gigs"
      :key="gig.id"
      :gig="gig"
    />
  </div>

  <p v-else>
    No gigs founds.
  </p>
</template>

<script>
import GigComponent from './GigComponent.vue';

export default {
  components: {
    GigComponent,
  },
  props: {
    gigs: {
      default: () => [],
      type: Array,
    },
  },
};
</script>
